import { Bug, CalendarClock, Copy, FileText, Hammer, ListTodo, MessageCircleQuestion, Search, Wrench } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { ContextPick } from "./types";

export interface Starter { icon: LucideIcon; text: string }

/* Conversation starters on an empty chat. */
const STARTERS: Starter[] = [
  { icon: ListTodo, text: "Draft a project kickoff plan" },
  { icon: FileText, text: "Summarize a document I'll upload" },
  { icon: Search, text: "Research a market and cite sources" },
];
/* ...and on an empty conversation with Builder, about the agents it builds. */
const BUILDER_STARTERS: Starter[] = [
  { icon: Hammer, text: "Help me build a new agent" },
  { icon: Bug, text: "Find out why one of my agents isn't doing its job" },
  { icon: CalendarClock, text: "Set one of my agents to run every morning" },
];
const NEW_AGENT_STARTERS: Starter[] = [
  { icon: MessageCircleQuestion, text: "Ask me what the new agent should do" },
  { icon: Copy, text: "Start from a copy of one of my agents" },
];
const startersAbout = (name: string): Starter[] => [
  { icon: Bug, text: `Find out why ${name} isn't doing its job` },
  { icon: CalendarClock, text: `Run ${name} every morning` },
  { icon: Wrench, text: `Add a tool to ${name}` },
];

/** How an empty chat opens: its starters, and the composer's placeholder (undefined: the
    composer's own "Message <agent>…"). Builder's follow its picker: the agent it names, a new
    one, or any. */
export function openingFor(builder: boolean, pick: ContextPick): { starters: Starter[]; placeholder?: string } {
  if (!builder) return { starters: STARTERS };
  if (pick?.kind === "agent") return { starters: startersAbout(pick.agent.name), placeholder: `Ask Builder about ${pick.agent.name}…` };
  if (pick?.kind === "new") return { starters: NEW_AGENT_STARTERS, placeholder: "Describe the agent you want…" };
  return { starters: BUILDER_STARTERS };
}
